import {ColumnDef} from "@tanstack/react-table";

import {CustomActionResultRecordModel} from "@/api/models/actions/customAction";
import {Switch} from "@/components/ui/switch";

const useCustomActionResultsColumns = () => {
  const columns: ColumnDef<CustomActionResultRecordModel>[] = [
    {
      accessorKey: "name",
      header: "NAME",
      cell: ({row}) => (
        <span className="text-primary text-base text-ellipsis">
          {row.original.name}
        </span>
      ),
    },
    {
      id: "actions",
      meta: {
        align: "right",
      },
      cell: ({row}) => {
        return (
          <Switch
            id={row.original.id}
            checked={row.getIsSelected()}
            onCheckedChange={value => row.toggleSelected(!!value)}
          />
        );
      },
      size: 20,
      maxSize: 20,
    },
  ];

  return {columns};
};

export default useCustomActionResultsColumns;
